import { render, staticRenderFns } from "./FormImagemContentComponent.vue?vue&type=template&id=30eb6b23&scoped=true&"
import script from "./FormImagemContentComponent.vue?vue&type=script&lang=js&"
export * from "./FormImagemContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormImagemContentComponent.vue?vue&type=style&index=0&id=30eb6b23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eb6b23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VForm,VIcon,VLayout})
